export default class AdContactFormToggle {
  constructor() {
    if (!this.vars()) return false;
    this.setupEvents();
  }

  vars() {
    this.selectors = {
      wrapper: 'noticeFormWrapper',
      active: 'noticeFormWrapper--showForm',
      button: 'data-toggle-user-contact',
    };

    this.wrapper = document.querySelector(`.${this.selectors.wrapper}`);
    this.buttons = Array.from(document.querySelectorAll(`[${this.selectors.button}]`));

    if (!this.wrapper || !this.buttons.length) return false;

    return true;
  }

  setupEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.toggle());
    });
  }

  toggle() {
    if (this.wrapper.classList.contains(this.selectors.active)) {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    this.wrapper.classList.remove(this.selectors.active);
    this.buttons.forEach((button) => button.innerText = 'Napisz do mnie!');
  }

  open() {
    this.wrapper.classList.add(this.selectors.active);
    this.buttons.forEach((button) => button.innerText = 'Pokaż ogłoszenie');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Components/AdContactFormToggle.js